import { ScrollTrigger } from "gsap/ScrollTrigger";

window.addEventListener("load", () => {
  ScrollTrigger.refresh(); // ensure correct trigger positions
  scrollToHashIfNeeded();
});

function scrollToHashIfNeeded() {
  const hash = window.location.hash;
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      // Allow some delay if needed (e.g. for layout shift)
      setTimeout(() => {
        target.scrollIntoView({ behavior: "auto" });
      }, 100);
    }
  }
}